export default {
  create: {
    title: 'Adicionar',
    subtitle: 'Criptograma',
  },
  edit: {
    title: 'Editar',
    subtitle: 'Jogo',
    button: {
      add: 'Novo jogo',
    },
  },
  list: {
    title: 'Criptogramas',
    subtitle: 'Lista',
    add: 'Novo jogo',
  },
  card: {
    title: 'Gerador de criptogramas',
    actions: 'Ações',
  },
  table: {
    title: 'Jogos Ativos',
    searchPlaceholder: 'Procurar por algo...',
  },
  form: {
    name: {
      label: 'Nome:',
      invalid: 'Nome é obrigatório',
    },
    font: {
      label: 'Selecionar fonte:',
    },
    theme: {
      label: 'Estilo do jogo:',
      default: 'Tema Padrão',
      radius: 'Arredondado',
      molotov: 'Molotov',
    },
    columns: 'Colunas:',
    rows: 'Linhas:',
    hint: 'Clique duplo para trocar a cor do fundo.',
  },
  button: {
    fillWords: 'Preencher Palavras',
    clearGame: 'Limpar Jogo',
    printGame: 'Imprimir Jogo',
    printAnswers: 'Imprimir Respostas',
    addQuestion: 'Adicionar nova questão',
    editQuestion: 'Editar questão',
  },
  cell: {
    fillWord: 'Preencher resto da palavra aleatoriamente',
    clearLine: 'Limpar linha',
  },
  alert: {
    wordCompleted: 'Palavra completada com sucesso!',
    cryptogramCleared: 'Criptograma limpo!',
    wordNotFound: 'Nenhuma palavra encontrada!',
    questionAdded: 'Questão adicionada com sucesso!',
    questionDeleted: 'Questão deletada com sucesso!',
    questionEdited: 'Questão editada com sucesso!',
  },
};
